import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAddProductInquiryAnswer } from "../../../../../api/inquiries/product-inquiry/use-product-inquiry-answer";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import { convertDateToDateTime } from "../../../../../helper/formatDate/formate-date";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";

const DetailItem = ({ data }) => {
  const navigate = useNavigate();
  const [isEditMode, setIsEditMode] = useState(false);
  const defaultHasAnswer = data?.answer?.length > 0;
  const [answer, setAnswer] = useState(data?.answer ?? "");
  const { mutate: addProductInquiryAnswer } = useAddProductInquiryAnswer();

  const handleBackToList = () => {
    navigate("/bulletin-board");
  };

  const toggleEdit = () => {
    setIsEditMode(!isEditMode);
  };

  const onChangeAnswer = (e) => {
    setAnswer(e.target.value);
  };

  const handleSubmitInquiry = async () => {
    const payload = {
      id: data?.id,
      answer: answer,
    };
    try {
      await addProductInquiryAnswer(payload);
      setIsEditMode(false);
    } catch (error) {}
  };

  return (
    <div className="mt-3">
      <div>
        <h2 className="font-bold text-[14px]">상품 문의</h2>
        <div className="mt-[10px]">
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="분류">
                <span className="p-2">상품 문의</span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="문의일시">
                <span className="p-2">
                  {convertDateToDateTime(data?.createdAt)}
                </span>
              </FieldBox>
            </div>
          </div>
          <FieldBox label="작성자">
            <span className="p-2">
              ({data?.hospital?.name}) {data?.hospitalMember?.email}
            </span>
          </FieldBox>
          <FieldBox label="상품명">
            <span className="p-2">{data?.productGroup?.name}</span>
          </FieldBox>
          <FieldBox isLast label="문의 내용">
            <div className="p-2 min-h-[100px]">{data?.question}</div>
          </FieldBox>
        </div>
      </div>
      <div className="mt-[30px]">
        <div className="flex justify-between items-center">
          <h2 className="font-bold text-[14px]">관리자 답변</h2>
          {!isEditMode && (
            <Button
              onClick={toggleEdit}
              primary
              text={defaultHasAnswer ? "답변수정" : "답변하기"}
            />
          )}
        </div>
        <div className="mt-[10px]">
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="처리상태">
                {data?.status === "PENDING" ? (
                  <span className="text-[#e80000]">답변대기</span>
                ) : (
                  "답변완료"
                )}
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="답변일시">
                <span className="p-2">
                  {data?.answeredAt
                    ? convertDateToDateTime(data?.answeredAt)
                    : ""}
                </span>
              </FieldBox>
            </div>
          </div>
          <FieldBox
            className={`${!isEditMode ? "bg-[#fafafa]" : ""} text-[#999999]`}
            isLast
            label="답변 내용"
          >
            {isEditMode ? (
              <textarea
                className="p-2 min-h-[200px] w-full focus:outline-none text-black"
                onChange={onChangeAnswer}
                defaultValue={defaultHasAnswer ? data?.answer : ""}
                placeholder="답변을 입력해주세요."
              />
            ) : (
              <div className="p-2 min-h-[200px] text-black">
                {data?.answer ?? "등록된 답변이 없습니다. "}
              </div>
            )}
          </FieldBox>
        </div>
      </div>
      {!isEditMode ? (
        <div className="mt-[30px] flex justify-center">
          <Button
            onClick={handleBackToList}
            className="py-[8.5px]"
            text="목록"
          />
        </div>
      ) : (
        <div className="mt-[30px] flex justify-end">
          <div className="flex items-center gap-3">
            <Modal
              description={
                <span>
                  입력한 답변을 입력취소하시겠습니까? 취소할 경우, 입력한 정보는
                  저장
                  <br />
                  되지 않습니다.
                </span>
              }
              onSubmit={() => setIsEditMode(false)}
            >
              <Button type="button" className="py-[8.5px]" text="입력취소" />
            </Modal>
            <Modal
              description={
                <span>
                  입력한 답변을 등록하시겠습니까? 등록완료가 될 경우, 회원에게
                  관리자
                  <br />
                  답변 알림이 발송됩니다
                </span>
              }
              onSubmit={handleSubmitInquiry}
            >
              <Button
                type="button"
                primary
                className="py-[8.5px]"
                text={defaultHasAnswer ? "수정완료" : "등록완료"}
                isDisabled={answer === ""}
              />
            </Modal>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailItem;
